export const AUTHENTICATE = "AUTHENTICATE";

export const LOGOUT = "LOGOUT";

export const ADDINTEREST = "ADDINTEREST";
export const SETINTERESTS = "SETINTERESTS";
export const ADDINTERESTUNIT = "ADDINTERESTUNIT";
export const DELETEINTERESTUNIT = "DELETEINTERESTUNIT";
export const ADDINTERESTRESALE = "ADDINTERESTRESALE";
export const DELETEINTERESTRESALE = "DELETEINTERESTRESALE";
export const SETNAVIGATE = "SETNAVIGATE";
export const CURRENCY = "CURRENCY";
export const LOADINGHOME = "LOADINGHOME";
